import type { EntryHeaderFieldConfig } from "./types";

export const COMMUNITY_ID = "communityId";
export const DOCUMENT_NO = "postDocumentHeaderId";
export const INCLUDE_PERIOD_0 = "includePeriod0";
export const HIDE_ZERO_BALANCES = "hideZeroBalances";
export const SHOW_LONG_DESCRIPTION = "showLongDescription";
export const ENTRY_DOCUMENT_TYPE = "documentType";
export const ENTRY_DOCUMENT_ID = "documentId";
export const ENTRY_BILLING_MONTH_YEAR = "billingMonthYear";
export const ENTRY_BILLING_DATE = "billingDate";
export const ENTRY_BILLING_AMOUNT = "billingAmount";
export const ENTRY_DUE_DATE = "dueDate";
export const ENTRY_TRANSACTION_TYPE = "transactionType";
export const ENTRY_GL_ACCOUNT = "glAccount";
export const ENTRY_PAYMENT_TERM = "paymentTerm";
export const ENTRY_PROPERTY_ID = "propertyId";
export const ENTRY_PROPERTY_NAME = "name";
export const ENTRY_BILLING_CATEGORY = "categoryName";
export const ENTRY_PROPERTY_MODEL = "modelName";
export const ENTRY_PROPERTY_BLOCK = "blockName";
export const ENTRY_UNIT_NO = "unitNumber";
export const ENTRY_STREET_ADDRESS = "addressLine1";
export const ENTRY_CURR_OWNER_ID = "ownershipId";
export const ENTRY_CURR_OWNER_LAST_NAME = "lastName";
export const ENTRY_DRCR = "drCr";
export const ENTRY_LINE_BILLING_AMOUNT = "amount";
export const ENTRY_ITEM_TEXT = "itemText";
// Invoice Header
export const DOCUMENT_ID = "parkDocumentHeaderId";
export const DOCUMENT_TYPE = "documentTypeId";
export const VENDOR_ID = "vendorId";
export const INVOICE_NUMBER = "invoiceNumber";
export const INVOICE_REFERENCE = "invoiceRef";
export const INVOICE_AMOUNT = "invoiceAmount";
export const INVOICE_CURRENCY = "invoiceCurrency";
export const APPROVED_AMOUNT = "approvedAmount";
export const PAYMENT_TERMS = "paymentTerms";
export const DUE_DATE = "dueDate";
export const INVOICE_DATE = "invoiceDate";
export const BASELINE_DATE = "baselineDate";
export const PAYMENT_METHODS = "paymentMethod";
export const POSTING_DATE = "postingDate";
export const POSTING_MONTH = "postingMonth";
export const YEAR = "postingYear";
export const PAYMENT_BLOCK = "paymentBlock";
export const BLOCK_DATE = "blockDate";
export const BLOCK_BY = "blockBy";
export const ATTACHMENT = "attachment";
export const ATTACHMENT_ID = "attachmentId";
export const COMMENT = "comment";
export const DOC_STATUS = "documentStatus";

// Invoice line items
export const PARK_ITEM_ID = "parkDocumentLineItemId";
export const LINE_ITEMS = "lineItems";
export const CHECK = "check";
export const GL_ACCOUNT_ID = "glMasterId";
export const ALT_GL_ACCOUNT_ID = "alternativeAccountId";
export const DRCR = "drCr";
export const UNIT = "numberOfUnits";
export const RATE_PER_UNIT = "ratePerUnit";
export const AMOUNT = "amount";
export const APPROVED_UNIT = "approvedUnits";
export const APPROVED_RATE_PER_UNIT = "approvedRatePerUnit";
export const APP_AMOUNT = "appAmount";
export const BUDGET_YEAR = "budgetYear";
export const BUDGET_MONTH = "budgetMonth";
export const BUDGET_START_MONTH = "budgetMonthStart";
export const BUDGET_END_MONTH = "budgetMonthEnd";
export const ITEM_TEXT = "itemText";
export const APPROVAL_STATUS = "approvalStatus";
export const LINE_ITEM_COMMENTS = "lineItemComment";
export const SHORT_DESC = "accountShortDesc";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
export const headerColumnOptions = [
  { key: "communityId", label: "Community ID", checked: true },
  { key: "postingYear", label: "Year", checked: true },
  { key: "postingPeriod", label: "Posting Period", checked: true },
  { key: "transactionalProcessor", label: "Transactional Processor", checked: true },
  { key: "documentType", label: "Document Type", checked: true },
  { key: "transactionType", label: "Transaction Type", checked: true },
  { key: "vendorId", label: "Vendor Id", checked: true },
  { key: "contractId", label: "Contract ID", checked: true },
  { key: "invoiceNumber", label: "Invoice No.", checked: false },
  { key: "comments", label: "Header Text", checked: false },
  { key: "billingCategory", label: "Billing Category", checked: true },
];

export const lineItemColumnOptions = [
  { key: "lineId", label: "Line ID", checked: true },
  { key: "itemText", label: <>Line Item Text</>, checked: true },
  { key: "glAccountNumber", label: <>GL Account<br/>Number</>, checked: true },
  { key: "glAccountDescription", label: "GL Account", checked: true },
  { key: "approvalStatus", label: "Approved", checked: true },
  { key: "approvalLevel", label: "Approval Level", checked: true },
  { key: "postingDate", label: <>Approval<br/>Date</>, checked: true },
  { key: "drCr", label: <>Dr/Cr</>, checked: true },
  { key: "amount", label: <>Amount</>, checked: true },
  { key: "currency", label: "Currency", checked: false },
];

export const entryHeaderColumnOptions = [
  { key: ENTRY_DOCUMENT_TYPE, label: "Document Type", checked: true },
  { key: ENTRY_DOCUMENT_ID, label: "Document ID", checked: true },
  { key: ENTRY_BILLING_MONTH_YEAR, label: "Billing Month/Year", checked: true },
  { key: ENTRY_BILLING_DATE, label: "Billing Date", checked: true },
  { key: ENTRY_BILLING_AMOUNT, label: "Billing Amount", checked: true },
  { key: ENTRY_DUE_DATE, label: "Due Date", checked: true },
  { key: ENTRY_TRANSACTION_TYPE, label: "Transaction Type", checked: true },
  { key: ENTRY_PAYMENT_TERM, label: "Payment Term", checked: true },
];

export const entryHeaderFieldConfigs: EntryHeaderFieldConfig[] = [
  {
    key: ENTRY_DOCUMENT_TYPE,
    label: "Document Type",
    placeholder: "Please select",
    fieldType: "select",
  },
  {
    key: ENTRY_DOCUMENT_ID,
    label: "Document Id",
    placeholder: "Please enter",
    fieldType: "input",
  },
  {
    key: ENTRY_BILLING_MONTH_YEAR,
    label: "Billing Month/Year",
    placeholder: "Select",
    fieldType: "input",
  },
  {
    key: ENTRY_BILLING_DATE,
    label: "Posting Date",
    placeholder: "Please select",
    fieldType: "date",
  },
  {
    key: ENTRY_BILLING_AMOUNT,
    label: "Billing Amount",
    placeholder: "Please enter",
    fieldType: "input",
    startIcon: "$",
    variant: "float",
  },
  {
    key: ENTRY_DUE_DATE,
    label: "Due Date",
    placeholder: "Please select",
    fieldType: "date",
  },
  {
    key: ENTRY_TRANSACTION_TYPE,
    label: "Transaction Type",
    placeholder: "Please select",
    fieldType: "select",
  },
  {
    key: ENTRY_PAYMENT_TERM,
    label: "Payment Term",
    placeholder: "Please select",
    fieldType: "input",
  },
];

export const entryLineItemColumnOptions = [
  { key: ENTRY_PROPERTY_ID, label: "Property ID", checked: true },
  { key: ENTRY_PROPERTY_NAME, label: "Property Name", checked: true },
  { key: ENTRY_BILLING_CATEGORY, label: "Billing Category", checked: true },
  { key: ENTRY_PROPERTY_MODEL, label: "Prop Model", checked: true },
  { key: ENTRY_PROPERTY_BLOCK, label: "Prop Block", checked: true },
  { key: ENTRY_UNIT_NO, label: "Unit No.", checked: true },
  { key: ENTRY_STREET_ADDRESS, label: "Street Address", checked: true },
  { key: ENTRY_CURR_OWNER_ID, label: "Cur. Owner ID", checked: true },
  { key: ENTRY_CURR_OWNER_LAST_NAME, label: "Cur. Owner Last Name", checked: true },
  { key: ENTRY_DRCR, label: "Dr/Cr", checked: true },
  { key: ENTRY_LINE_BILLING_AMOUNT, label: "Billing Amt.", checked: true },
  { key: ENTRY_ITEM_TEXT, label: "Line Item Text", checked: true },
];
export const invoiceHeaderColumnOptions = [
  { key: DOCUMENT_TYPE, label: "Document Type", checked: true },
  { key: DOCUMENT_ID, label: "Document Id", checked: true },
  { key: VENDOR_ID, label: "Vendor Name", checked: true },
  { key: INVOICE_NUMBER, label: "Invoice Number", checked: true },
  { key: INVOICE_DATE, label: "Invoice Date", checked: true },
  { key: BASELINE_DATE, label: "Baseline Date", checked: true },
  { key: INVOICE_REFERENCE, label: "Invoice Reference", checked: true },
  { key: INVOICE_AMOUNT, label: "Invoice Amount", checked: true },
  { key: APPROVED_AMOUNT, label: "Approved Amount", checked: true },
  { key: POSTING_DATE, label: "Posting Date", checked: true },
  { key: DUE_DATE, label: "Due Date", checked: true },
  { key: COMMENT, label: "Header Text", checked: true },
];
export const invoiceLineItemColumnOptions = [
  { key: GL_ACCOUNT_ID, label: "GL Account", checked: true },
  { key: ALT_GL_ACCOUNT_ID, label: "ALT. GL Account", checked: true },
  { key: DRCR, label: "Dr/Cr", checked: true },
  { key: UNIT, label: "# Unit", checked: true },
  { key: RATE_PER_UNIT, label: "Rate Per", checked: true },
  { key: AMOUNT, label: "Amount", checked: true },
  { key: APPROVED_UNIT, label: "Approved # Unit", checked: true },
  { key: APPROVED_RATE_PER_UNIT, label: "Approved Rate Per Unit", checked: true },
  { key: APP_AMOUNT, label: "Approved Amount", checked: true },
  { key: BUDGET_MONTH, label: "Budget Month & Year", checked: true },
  { key: ITEM_TEXT, label: "Item Text", checked: true },
];
